import React from 'react';
import SIcon from './SIcon';
import { faBolt } from '@fortawesome/pro-solid-svg-icons';

const Icon = props => <SIcon {...props} icon={faBolt} fa />;

export default Icon;
